/**
 * Public facing event callbacks that can be registered by the integration
 * to interrupt the player UI action.
 */
export var PlayerInterruptEvent;
(function (PlayerInterruptEvent) {
    PlayerInterruptEvent["onLivestreamEnterCallback"] = "livestream-enter";
    PlayerInterruptEvent["onLivestreamChatInputFocusCallback"] = "livestream-chat-input-focus";
    PlayerInterruptEvent["onLivestreamInteractionGiveawayEnterCallback"] = "livestream-interaction-giveaway-enter";
    PlayerInterruptEvent["onLivestreamInteractionTriviaGiveawayEnterCallback"] = "livestream-interaction-trivia-giveaway-enter";
    PlayerInterruptEvent["onLivestreamInteractionPollEnterCallback"] = "livestream-interaction-poll-enter";
    PlayerInterruptEvent["onLivestreamInteractionQuestionEnterCallback"] = "livestream-interaction-question-enter";
    PlayerInterruptEvent["onLivestreamInteractionHeartCallback"] = "livestream-interaction-heart";
})(PlayerInterruptEvent || (PlayerInterruptEvent = {}));
